import { useTheme } from "@mui/material/styles";

interface UncheckedIconProps {
  square?: boolean;
}

function UncheckedIcon({ square = false }: UncheckedIconProps) {
  const { palette } = useTheme();
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      {square ? (
        <>
          <rect width="24" height="24" rx="8" fill={palette.common.white} />
          <rect
            x="0.5"
            y="0.5"
            width="23"
            height="23"
            rx="7.5"
            fill={palette.common.white}
            stroke={palette.divider}
          />
        </>
      ) : (
        <>
          <rect width="24" height="24" rx="12" fill={palette.common.white} />
          <rect
            x="0.5"
            y="0.5"
            width="23"
            height="23"
            rx="11.5"
            stroke={palette.divider}
          />
        </>
      )}
    </svg>
  );
}

export default UncheckedIcon;
